import { motion } from 'framer-motion'

interface PresentationCardSkeletonProps {
  viewMode?: 'grid' | 'list'
}

export function PresentationCardSkeleton({ viewMode = 'grid' }: PresentationCardSkeletonProps) {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      className={`bg-card border rounded-lg overflow-hidden ${
        viewMode === 'grid' ? 'w-full' : 'flex gap-4'
      }`}
    >
      {/* Thumbnail skeleton */}
      <div
        className={`relative bg-gradient-to-br from-blue-500/20 to-purple-500/20 rounded-lg overflow-hidden ${
          viewMode === 'grid' ? 'aspect-video' : 'w-48 h-32 flex-shrink-0'
        }`}
      >
        {/* Shimmer effect */}
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/10 to-transparent animate-shimmer" />
      </div>

      {/* Content skeleton */}
      <div className={`p-4 space-y-3 ${viewMode === 'list' ? 'flex-1' : ''}`}>
        {/* Title skeleton */}
        <div className="space-y-2">
          <div className="h-6 bg-muted rounded animate-pulse" />
          <div className="h-4 bg-muted rounded w-3/4 animate-pulse" />
        </div>

        {/* Description skeleton */}
        <div className="space-y-1">
          <div className="h-3 bg-muted rounded w-full animate-pulse" />
          <div className="h-3 bg-muted rounded w-5/6 animate-pulse" />
          <div className="h-3 bg-muted rounded w-4/6 animate-pulse" />
        </div>

        {/* Metadata skeleton */}
        <div className="flex items-center gap-4 pt-2">
          {/* Slide count skeleton */}
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 bg-muted rounded animate-pulse" />
            <div className="h-3 bg-muted rounded w-12 animate-pulse" />
          </div>

          {/* Author skeleton */}
          <div className="flex items-center gap-2">
            <div className="w-4 h-4 bg-muted rounded animate-pulse" />
            <div className="h-3 bg-muted rounded w-20 animate-pulse" />
          </div>
        </div>

        {/* Tags skeleton */}
        <div className="flex items-center gap-2 pt-2">
          <div className="h-6 bg-muted rounded-full w-16 animate-pulse" />
          <div className="h-6 bg-muted rounded-full w-20 animate-pulse" />
          <div className="h-6 bg-muted rounded-full w-14 animate-pulse" />
        </div>
      </div>
    </motion.div>
  )
}
